angular.module('App.imageOnLoadDirective', [])
  .directive('imageonload', ($parse, $rootScope) => {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          $rootScope.logo_commercialisateur = true;
        });
      }
    };
  });
